import { render } from "./BaseInfoField.vue?vue&type=template&id=83eb87a8&scoped=true"
import script from "./BaseInfoField.vue?vue&type=script&lang=js"
export * from "./BaseInfoField.vue?vue&type=script&lang=js"

import "./BaseInfoField.vue?vue&type=style&index=0&id=83eb87a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83eb87a8"]])

export default __exports__